import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "vspo_cookie_consent"; // "accepted" | "refused"

export function setConsent(v) {
  try { localStorage.setItem(KEY, v); } catch (e) { console.debug("Consentement non enregistré:", e); }
}
export function getConsent() {
  try { return localStorage.getItem(KEY); } catch (e) { return null; }
}

// RGPD cookie/consent banner. The app only stores functional preferences and
// (for logged-in users) a session cookie; there is no third-party ad/tracking
// cookie. The banner lets users accept or refuse non-essential storage.
export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!getConsent());
  }, []);

  if (!visible) return null;

  const choose = (v) => {
    setConsent(v);
    setVisible(false);
  };

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[300] border-t border-border bg-card/95 p-4 backdrop-blur"
      data-testid="cookie-consent"
      role="dialog"
      aria-label="Consentement aux cookies"
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-3 sm:flex-row sm:items-center">
        <Cookie className="hidden h-6 w-6 shrink-0 text-primary sm:block" />
        <p className="flex-1 text-sm text-muted-foreground">
          vspo utilise un stockage local pour vos préférences (thème, voix) et, si vous vous connectez,
          un cookie de session. Aucune publicité ciblée ni pistage tiers.{" "}
          <Link to="/confidentialite" className="underline hover:text-foreground">Politique de confidentialité</Link>.
        </p>
        <div className="flex shrink-0 gap-2">
          <Button variant="outline" size="sm" onClick={() => choose("refused")} data-testid="cookie-refuse">
            Refuser
          </Button>
          <Button size="sm" onClick={() => choose("accepted")} data-testid="cookie-accept">
            Accepter
          </Button>
        </div>
      </div>
    </div>
  );
}
